import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import adminService from '../../api/adminService';
import { useNotifications } from '../../context/NotificationContext';
import LoadingSpinner from '../common/LoadingSpinner';
import Analytics from './Analytics';

export default function AdminDashboard() {
  const { t } = useTranslation();
  const notify = useNotifications();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminService.getStats().then(setStats).catch((e) => notify.apiError(e));
  }, [notify]);

  if (!stats) return <div className="page"><div className="container"><LoadingSpinner /></div></div>;

  const cards = [
    [t('admin.users'), stats.totalUsers],
    [t('admin.clients'), stats.totalClients],
    [t('admin.technicians'), stats.totalTechnicians],
    [t('admin.techPending'), stats.pendingTechnicians],
    [t('admin.bookingsToReview'), stats.pendingBookingApprovals],
    [t('admin.serviceRequestsNew'), stats.newServiceRequests],
    [t('admin.unreadMessages'), stats.unreadChatMessages],
    [t('admin.bookings'), stats.totalBookings],
    [t('admin.reviews'), stats.totalReviews],
  ];

  return (
    <div className="page">
      <div className="container stack" style={{ gap: '1.5rem' }}>
        <div className="page-head">
          <h1>{t('admin.overview')}</h1>
          <div className="row" style={{ gap: '.5rem' }}>
            {stats.pendingBookingApprovals > 0 && (
              <Link to="/review/bookings" className="btn accent">
                {stats.pendingBookingApprovals} · {t('admin.bookingsToReview')}
              </Link>
            )}
            {stats.pendingTechnicians > 0 && (
              <Link to="/review/technicians" className="btn ghost">
                {stats.pendingTechnicians} · {t('admin.techPending')}
              </Link>
            )}
            {stats.newServiceRequests > 0 && (
              <Link to="/review/service-requests" className="btn ghost">
                {stats.newServiceRequests} · {t('admin.serviceRequestsNew')}
              </Link>
            )}
          </div>
        </div>

        <div className="grid stats">
          {cards.map(([l, n]) => (
            <div key={l} className="stat"><div className="n">{n}</div><div className="l">{l}</div></div>
          ))}
        </div>

        <div className="split">
          <Analytics byStatus={stats.bookingsByStatus} />
          <div className="card pad stack">
            <strong>{t('admin.manage')}</strong>
            <Link to="/review/bookings">{t('admin.bookingReviewQueue')}</Link>
            <Link to="/review/technicians">{t('admin.technicianApplications')}</Link>
            <Link to="/review/service-requests">{t('serviceRequest.adminTitle')}</Link>
            <Link to="/review/chat">{t('chat.inboxTitle')}</Link>
            <Link to="/admin/users">{t('admin.usersAndRoles')}</Link>
            <Link to="/admin/services">{t('admin.tradeCategories')}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
